import React, { useEffect, useMemo, useState } from 'react';

import { Group, Select } from '@mantine/core';

import { ENT_TYPES } from '../../const';
import getStories from '../SearchSelect/facades/getStories.facade';
import SearchSelect from '../SearchSelect/SearchSelect';

const STORY_TYPES = ENT_TYPES.map((item) => ({ value: item.id, label: item.name }));

function StorySearchSelect({
    currentAlias,
    currentTitle,
    onChange,
}) {
    const [alias, setAlias] = useState('news');

    useEffect(() => {
        if (!currentAlias) {
            return;
        }

        setAlias(currentAlias);
    }, [currentAlias]);

    function handleStorySelect(data) {
        onChange({
            ...data,
            alias,
        });
    }

    const fetchProps = useMemo(() => ({
        alias,
    }), [alias]);

    return (
        <Group>
            <Select
                label="Тип материала"
                data={STORY_TYPES}
                value={alias}
                onChange={setAlias}
                style={{ flex: 0.4 }}
            />
            <SearchSelect
                label={currentTitle ? `Материал: ${currentTitle}` : 'Материал'}
                fetchFn={getStories}
                fetchProps={fetchProps}
                style={{ flex: 1 }}
                onChange={handleStorySelect}
            />
        </Group>
    );
}

export default StorySearchSelect;
